var moduleMap = {
	"./FederatedArtifactsPage": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(4018), __webpack_require__.e(5988)]).then(() => (() => ((__webpack_require__(15933)))));
	},
	"./FederatedArtifactRedirectPage": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(1731)]).then(() => (() => ((__webpack_require__(41731)))));
	},
	"./FederatedArtifactVersionPage": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(7985), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(2675), __webpack_require__.e(522), __webpack_require__.e(2292)]).then(() => (() => ((__webpack_require__(92908)))));
	},
	"./FederatedRulesPage": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(1444)]).then(() => (() => ((__webpack_require__(61444)))));
	},
	"./FederatedRolesPage": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(2675), __webpack_require__.e(7569)]).then(() => (() => ((__webpack_require__(24499)))));
	},
	"./FederatedSettingsPage": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(3669)]).then(() => (() => ((__webpack_require__(93669)))));
	},
	"./FederatedSchemaMapping": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366)]).then(() => (() => ((__webpack_require__(72058)))));
	},
	"./FederatedDownloadArtifacts": () => {
		return Promise.all([__webpack_require__.e(9539), __webpack_require__.e(9262), __webpack_require__.e(3264), __webpack_require__.e(4724), __webpack_require__.e(7383), __webpack_require__.e(1366), __webpack_require__.e(8581)]).then(() => (() => ((__webpack_require__(88581)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});